import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed,
  output,
} from '@angular/core';
import {
  BUTTON_VARIANT_CLASSES,
  ButtonVariant,
  SPINNER_STROKE_VARIANT_CLASSES,
  BUTTON_ACTION_VARIANT_CLASSES,
} from './button-variant';
import { SpinnerComponent } from '../spinner/spinner.component';

const BUTTON_GENERAL_CLASSES = 'tw-flex tw-items-center tw-justify-center tw-gap-spacing-100 tw-px-spacing-300 tw-py-spacing-150 tw-rounded-component-button-radius tw-font-general-font-family-body tw-text-button tw-h-[48px] focus-visible:tw-shadow-button-focus';

@Component({
  selector: 'app-button',
  templateUrl: 'button.component.html',
  imports: [
    CommonModule,
    SpinnerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'classes()',
  },
})

//TODO: Handle uppercase property, when webforms service for tokens is ready
export class ButtonComponent {
  public label = input.required<string>();
  public variant = input<ButtonVariant>('primary');
  public fullWidth = input<boolean>(false);
  public loading = input<boolean>(false);
  public disabled = input<boolean>(false);
  public type = input<string>('submit');

  public readonly clicked = output<void>();

  protected readonly actionable = computed(() => !(this.loading() || this.disabled()));

  protected readonly classes = computed(() => `tw-block ${this.fullWidth() ? 'tw-w-full' : ''}`);
  protected readonly buttonClasses = computed(() => this.getButtonClasses());
  protected readonly strokeClass = computed(() => SPINNER_STROKE_VARIANT_CLASSES[this.variant()]);

  private getButtonClasses(): string {
    return `${BUTTON_GENERAL_CLASSES} ${BUTTON_VARIANT_CLASSES[this.variant()]} ${this.actionable() ? '' : BUTTON_ACTION_VARIANT_CLASSES[this.variant()]}`;
  }

}
